import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "chatType", "dmTab", "groupTab",
    "groupName", "groupNameInput",
    "search", "userRow", "submitButton"
  ]

  connect() {
    this._updateSubmitButton()
  }

  selectDm() {
    this.chatTypeTarget.value = "direct_message"

    // Segmented control state
    this._setTabActive(this.dmTabTarget, true)
    this._setTabActive(this.groupTabTarget, false)

    // Show/hide group name
    if (this.hasGroupNameTarget) this.groupNameTarget.classList.add("hidden")
    if (this.hasGroupNameInputTarget) {
      this.groupNameInputTarget.removeAttribute("required")
      this.groupNameInputTarget.value = ""
    }

    this._updateSubmitButton()
  }

  selectGroup() {
    this.chatTypeTarget.value = "group_chat"

    // Segmented control state
    this._setTabActive(this.dmTabTarget, false)
    this._setTabActive(this.groupTabTarget, true)

    // Show group name input
    if (this.hasGroupNameTarget) this.groupNameTarget.classList.remove("hidden")
    if (this.hasGroupNameInputTarget) {
      this.groupNameInputTarget.setAttribute("required", "")
      this.groupNameInputTarget.focus()
    }

    this._updateSubmitButton()
  }

  filter() {
    if (!this.hasSearchTarget) return
    const query = this.searchTarget.value.toLowerCase().trim()
    this.userRowTargets.forEach(row => {
      const name  = (row.dataset.userName  || "").toLowerCase()
      const email = (row.dataset.userEmail || "").toLowerCase()
      row.classList.toggle("hidden", query.length > 0 && !name.includes(query) && !email.includes(query))
    })
  }

  onSelectionChange() {
    this._updateSubmitButton()
  }

  // -- private --

  _setTabActive(btn, active) {
    if (!btn) return
    btn.classList.toggle("bg-white",      active)
    btn.classList.toggle("shadow-sm",     active)
    btn.classList.toggle("text-slate-800", active)
    btn.classList.toggle("text-slate-500", !active)
  }

  _updateSubmitButton() {
    if (!this.hasSubmitButtonTarget) return

    const checkedCount = this.userRowTargets.filter(row =>
      row.querySelector("input[type=checkbox]")?.checked
    ).length

    const isGroup = this.hasChatTypeTarget && this.chatTypeTarget.value === "group_chat"
    const hasGroupName = !isGroup || (this.hasGroupNameInputTarget && this.groupNameInputTarget.value.trim().length > 0)
    const hasEnough = isGroup ? checkedCount >= 2 : checkedCount >= 1

    this.submitButtonTarget.disabled = !(hasGroupName && hasEnough)
  }
}
